var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-alert",
        {
          staticClass: "ma-0 pa-2",
          attrs: {
            color: "error",
            icon: "error",
            outline: "",
            value: !_vm.loading.service && !_vm.isServiceActive,
          },
        },
        [
          _c("div", { staticClass: "primary--text" }, [
            _vm._v(
              "\n      Sorry, the notification system cannot be reached right now. Please reload the page in a few minutes — let\n      us know\n      if the issue persists!\n    "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }